<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <h1>
          {{$t('pagesInvest.add.title')}}
          <span v-if="invest">: {{ invest.name }}</span>
        </h1>
      </v-flex>
      <v-flex xs12 py-0 mb-5>
        <v-divider />
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 py-0>
        <span @click="backToList" class="goback">{{$t('pagesInvest.add.gotoBack')}}</span>
      </v-flex>
    </v-layout>
    <loading :text="$t('pagesInvest.add.loadingData')" v-if="isLoadingEditMode" />
    <v-layout row wrap text-center tender__not-found v-if="errorDie">
      <v-flex xs12>
        <h1>{{ errorDie }}</h1>
      </v-flex>
    </v-layout>

    <v-stepper
      v-if="!errorDie && !isLoadingEditMode"
      v-model="addModalStep"
      :alt-labels="false"
      :vertical="verticalStep"
    >
      <!-- <template v-if="verticalStep">
        <template v-for="(step, n) in addModalSteps">
          <v-stepper-step
            :key="`${n}-step`"
            :complete="step.complete"
            :step="n + 1"
            :editable="step.editable"
            >{{ step.title }}</v-stepper-step
          >

          <v-stepper-content
            v-for="(step, n) in addModalSteps"
            :key="`${n}-content`"
            :step="n"
          >
            <v-card
              class="mb-12"
              color="grey lighten-1"
              height="200px"
            ></v-card>
            <v-btn v-if="n > 1" outlined class="mr-2" text @click="prevStep(n)"
              >Назад</v-btn
            >
            <v-btn color="primary" @click="nextStep(n)">Далее</v-btn>
          </v-stepper-content>
        </template>
      </template> -->
      <template vvv-else>
        <v-stepper-header>
          <template v-for="(step, n) in addModalSteps">
            <v-stepper-step
              :key="`${n}-step`"
              :complete="step.complete"
              :step="n + 1"
              :editable="step.editable"
              >{{ step.title }}</v-stepper-step
            >

            <v-divider
              v-if="n !== addModalSteps.length - 1"
              :key="n"
            ></v-divider>
          </template>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content
            v-for="(step, n) in addModalSteps"
            :key="`${n}-content`"
            :step="n + 1"
            class="pa-1"
          >
            <v-card class="mb-3 pa-3" tile :min-height="stepMinHeight">
              <!-- FIRST STEP -->
              <form v-if="n == 0">
                <v-card-text>
                  <company-search
                    :dadata="searchCompanyDaData"
                    :onChangeCallback="onChangeCallbackCompanySearch"
                  ></company-search>
                </v-card-text>
                <v-card-text>
                  <v-text-field
                    v-model="stepsModel[1].title"
                    :label="$t('pagesInvest.add.fields.name.label')"
                    clearable
                    :counter="128"
                    :placeholder="$t('pagesInvest.add.fields.name.placeholder')"
                    required
                    :rules="rules.rule"
                  ></v-text-field>
                </v-card-text>
                <v-card-text>
                  <v-textarea
                    v-model="stepsModel[1].name"
                    :label="$t('pagesInvest.add.fields.title')"
                    outlined
                    clearable
                    :counter="512"
                    no-resize
                    :rules="rules.rule"
                    required
                  ></v-textarea>
                </v-card-text>
                <v-card-text>
                  <v-select
                    v-model="stepsModel[1].type"
                    :items="typeOffers"
                    :label="$t('pagesInvest.add.fields.type')"
                    :rules="rules.rule"
                    required
                  ></v-select>
                </v-card-text>
                <v-card-text v-if="stepsModel[1].type == 4">
                  <v-select
                    v-model="stepsModel[1].sub_type"
                    :items="plegeSubTypes"
                    :label="$t('pagesInvest.add.fields.sub_type')"
                    :rules="rules.rule"
                    required
                  ></v-select>
                </v-card-text>
              </form>

              <!-- Проценты и суммы STEP -->
              <form v-if="n == 1">
                <v-card-text>
                  <v-select
                    v-model="stepsModel[2].currency"
                    :items="currencyList"
                    :label="$t('pagesInvest.add.fields.currency')"
                    :rules="rules.rule"
                    required
                  ></v-select>
                </v-card-text>
                <v-card-text>
                  <v-select
                    v-model="stepsModel[2].currency_callback"
                    :items="currencyList"
                    :label="$t('pagesInvest.add.fields.currency_callback')"
                    :rules="rules.rule"
                    required
                  ></v-select>
                </v-card-text>

                <v-card-text v-if="stepsModel[1].type != 4">
                  <v-layout row wrap>
                    <v-flex md4>
                      <v-text-field
                        v-model="stepsModel[2].price_min"
                        :label="$t('pagesInvest.add.fields.price_min')"
                        type="number"
                        required
                        :rules="rulesMinInvestPrice"
                        :append-icon="currencyInvestIcon"
                        id="price_min"
                        ref="price_min"
                        iinput="onInputPriceMin"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="stepsModel[2].price_max"
                        :label="$t('pagesInvest.add.fields.price_max')"
                        type="number"
                        required
                        :append-icon="currencyInvestIcon"
                        :rules="rulesMaxInvestPrice"
                        id="price_max"
                        ref="price_max"
                        iinput="onInputPriceMax"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-text v-if="stepsModel[1].type == 4">
                  <v-layout row wrap>
                    <v-flex md4>
                      <v-text-field
                        v-model="stepsModel[2].complete_price"
                        :label="$t('pagesInvest.add.fields.complete_price')"
                        type="number"
                        required
                        :rules="rules.rule"
                        :append-icon="currencyInvestIcon"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-text v-if="stepsModel[1].type != 4">
                  <v-layout row wrap>
                    <v-flex md4>
                      <v-text-field
                        v-model="stepsModel[2].month_min"
                        :label="$t('pagesInvest.add.fields.month_min')"
                        type="number"
                        required
                        :rules="rulesMinInvestMonth"
                        :error="cErrorMin"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4>
                      <v-text-field
                        v-model="stepsModel[2].month_max"
                        :label="$t('pagesInvest.add.fields.month_max')"
                        type="number"
                        required
                        :error="cErrorMin"
                        :rules="rulesMaxInvestMonth"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-text v-if="stepsModel[1].type == 4">
                  <v-layout row wrap>
                    <v-flex md4>
                      <v-text-field
                        v-model="stepsModel[2].month_max"
                        :label="$t('pagesInvest.add.fields.month_onmax')"
                        type="number"
                        required
                        :rules="rules.rule"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-text v-if="stepsModel[1].type != 4">
                  <v-layout row wrap>
                    <v-flex md8>
                      <list-from-to
                        :exist-value="percentTableExist"
                        v-on:change="changeListFromToPercent"
                      ></list-from-to>
                    </v-flex>
                  </v-layout>
                </v-card-text>

                <v-card-text v-if="stepsModel[1].type == 4">
                  <v-layout row wrap>
                    <v-flex md4>
                      <v-text-field
                        v-model="stepsModel[2].percent"
                        :label="$t('pagesInvest.add.fields.percent')"
                        type="number"
                        required
                        :rules="rules.rule"
                        append-icon="mdi-percent-outline"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </form>

              <!-- Описание STEP -->
              <form v-if="n == 2">
                <v-card-text>
                  <h2 class="my-5">
                    {{$t('pagesInvest.add.fields.imageListTitle')}}
                    <div class="subtitle-1 font-weight-light">
                      {{$t('pagesInvest.add.fields.imageListDescription')}}
                    </div>
                  </h2>
                  <v-divider class="mb-3 mt-3" />
                </v-card-text>
                <v-card-text v-if="!avatarFile">
                  <v-btn tile color="success" @click="onOpenBaseImageCropModal">
                    <v-icon left> mdi-plus </v-icon>
                    {{$t('pagesInvest.add.fields.addBaseImage')}}
                  </v-btn>
                </v-card-text>
                <v-card-text>
                  <!-- IMG EXIST -->
                  <div class="avatar-image-exist" v-if="avatarFile">
                     <v-img
                        class="elevation-4"
                        :width="374"
                        :height="250"
                        :min-width="374"
                        :min-height="250"
                        :src="getSrcPublicFile(avatarFile.id)"
                        cclick="onViewImage(file)"
                      ></v-img>
                      <div>
                        <v-btn
                          x-small
                          :loading="loadingBase"
                          color="red"
                          class="ma-2 white--text"
                          @click="onRemoveAvatar()"
                        >
                          <v-icon small left dark> mdi-delete </v-icon>
                          {{$t('pagesInvest.add.fields.delete')}}
                        </v-btn>
                      </div>
                  </div>

                  <v-dialog
                    v-model="dialogCropBaseImage"
                    width="800"
                    persistent
                  >
                    <v-layout
                      row
                      wrap
                      modal
                      modal__closable
                      bid__agreement-info
                    >
                      <span
                        class="modal__close"
                        @click="onCloseBaseImageCropModal"
                      ></span>
                      <v-flex xs12 modal__wrapper>
                        <!-- <v-card> -->
                        <v-card-text style="min-height: 400px">
                          <!-- <VueCropper v-show="selectedFile" ref="cropper" :src="selectedFile" alt="Source Image"></VueCropper> -->
                          <cropper
                            v-if="selectedFile"
                            ref="cropper"
                            canvas
                            class="cropper"
                            :src="selectedFile"
                            :stencil-props="{
                              aspectRatio: 374 / 250,
                            }"
                            @change="changeCropBaseImage"
                          ></cropper>
                        </v-card-text>
                        <v-card-actions>
                          <input
                            ref="FileInput"
                            type="file"
                            accept="image/*"
                            style="display: none"
                            @change="onFileSelect"
                          />
                          <v-btn
                            @click="openFileBaseImage"
                            :loading="loadingBase"
                            >{{$t('pagesInvest.add.fields.openImage')}}</v-btn
                          >
                          <v-btn
                            class="primary"
                            :loading="loadingBase"
                            v-if="cropData"
                            @click="saveImage()"
                            >{{$t('pagesInvest.add.fields.save')}}</v-btn
                          >
                          <!-- <v-btn
                              color="primary"
                              text
                              @click="onCloseBaseImageCropModal"
                              >Отмена</v-btn
                            > -->
                        </v-card-actions>
                        <!-- </v-card> -->
                      </v-flex>
                    </v-layout>
                  </v-dialog>
                </v-card-text>

                <v-card-text>
                  <h1>{{$t('pagesInvest.add.fields.h1About')}}</h1>
                  <v-divider class="mb-3 mt-3" />
                </v-card-text>
                <v-card-text>
                  <h2 class="mb-3">{{$t('pagesInvest.add.fields.aboutDescription')}}</h2>
                  <wysiwyg v-model="stepsModel[3].aboutText"></wysiwyg>
                  <h2 class="my-5">
                    {{$t('pagesInvest.add.fields.listParameters')}}
                    <div class="subtitle-1 font-weight-light">
                      {{$t('pagesInvest.add.fields.paramsDescription')}}
                    </div>
                  </h2>
                  <options-list
                    v-model="stepsModel[3].aboutOptions"
                  ></options-list>
                  <h2 class="my-5">
                    {{$t('pagesInvest.add.fields.aboutImages')}}
                    <div class="subtitle-1 font-weight-light">
                      {{$t('pagesInvest.add.fields.aboutImagesDescription')}}
                    </div>
                  </h2>
                  <gallery-list
                    v-model="stepsModel[3].aboutImages"
                  ></gallery-list>
                </v-card-text>

                <v-card-text>
                  <h1>{{$t('pagesInvest.add.fields.aboutBuisnes')}}</h1>
                  <v-divider class="mb-3 mt-3" />
                </v-card-text>
                <v-card-text>
                  <h2 class="mb-3">{{$t('pagesInvest.add.fields.buisnesDescription')}}</h2>
                  <wysiwyg v-model="stepsModel[3].businesText"></wysiwyg>
                  <h2 class="my-5">
                    {{$t('pagesInvest.add.fields.financialSettings')}}
                    <div class="subtitle-1 font-weight-light">
                      {{$t('pagesInvest.add.fields.financialDescription')}}
                    </div>
                  </h2>
                  <options-list
                    v-model="stepsModel[3].businesOptions"
                  ></options-list>
                  <h2 class="my-5">
                    {{$t('pagesInvest.add.fields.imageFinanceTitle')}}
                    <div class="subtitle-1 font-weight-light">
                      {{$t('pagesInvest.add.fields.imageFinanceDescription')}}
                    </div>
                  </h2>
                  <gallery-list
                    v-model="stepsModel[3].businesImages"
                  ></gallery-list>
                </v-card-text>
              </form>

              <!-- Документы STEP -->
              <form v-if="n == 3">
                <my-documents
                  v-if="invest"
                  :package-mode="invest.package.id"
                  :edit-mode="true"
                  :dop-button-name="$t('pagesInvest.add.fields.addDocumentsFile')"
                  :documents-data="stepsModel[4].documents.data"
                  v-on:updatePackageDocuments="updatePackageDocuments"
                  v-on:updateCustomPackageDocuments="
                    updateCustomPackageDocuments
                  "
                  :time-close-dialog="50"
                  :time-reset="100"
                />
              </form>

              <!-- End STEP -->

              <v-flex
                fill-height
                v-if="n == 4"
                xs12
                class="d-flex justify-center mt-12"
              >
                <v-flex class="d-flex flex-column">
                  <v-btn
                    color="orange"
                    dark
                    x-large
                    :loading="loadingNextButton"
                    @click="sendToVerificator()"
                    class="align-self-center"
                    >{{$t('pagesInvest.add.fields.sendVerification')}}</v-btn
                  >
                  <v-btn
                    class="mt-5 align-self-center"
                    outlined
                    large
                    :loading="loadingNextButton"
                    @click="backToList"
                    >{{$t('pagesInvest.add.fields.close')}}</v-btn
                  >
                </v-flex>
              </v-flex>
            </v-card>

            <v-btn
              v-if="n > 0"
              :loading="loadingNextButton"
              outlined
              class="mr-2"
              text
              @click="prevStep(n)"
              >{{$t('pagesInvest.add.actions.prev')}}</v-btn
            >
            <v-btn
              v-if="n < addModalSteps.length - 1"
              color="primary"
              :disabled="isDisabledNext(n)"
              :loading="loadingNextButton"
              @click="nextStep(n)"
              >{{$t('pagesInvest.add.actions.next')}}</v-btn
            >
          </v-stepper-content>
        </v-stepper-items>
      </template>
    </v-stepper>
  </v-container>
</template>

<script>
// import { mapGetters, mapState } from "vuex";
import { apiCallTrue } from "@/utils/api";
import formatPrice from "@/mixins/filters/formatPrice";
//import statusNames from "@/utils/data/statuses";
import showNotify from "@/services/noty";
//import investCalc from "@/components/invest/calc";
import CompanySearch from "@/components/lib/CompanySearch";
import ListFromTo from "@/components/invest/ListFromTo";
import OptionsList from "@/components/invest/OptionsList";
import GalleryList from "@/components/invest/Gallery";
import rules from "@/utils/data/rules";
import MyDocuments from "@/components/clients/documents";
import { Cropper } from "vue-advanced-cropper";
import { uploadFile } from "@/components/lib/file-upload.service";
import i18n from "@/services/i18n";

export default {
  name: "InvestAdd",
  //directives: { mask },
  mixins: [formatPrice],
  data: () => ({
    rules,
    isLoaded: false,
    invest: null,
    errorDie: null,
    isLoadingEditMode: false,

    verticalStep: false,
    addModalStep: 1,
    stepMinHeight: 300,
    addModalSteps: [
      { title: i18n.t('pagesInvest.add.tabs.1'), complete: false, editable: false },
      { title: i18n.t('pagesInvest.add.tabs.2'), complete: false, editable: false },
      { title: i18n.t('pagesInvest.add.tabs.3'), complete: false, editable: false },
      { title: i18n.t('pagesInvest.add.tabs.4'), complete: false, editable: false },
      { title: i18n.t('pagesInvest.add.tabs.5'), complete: false, editable: false },
    ],

    typeOffers: [
      {
        value: 1,
        text: i18n.t('investTypeOffers.1'),
        disabled: false,
      },
      {
        value: 2,
        text: i18n.t('investTypeOffers.2'),
        disabled: true,
      },
      {
        value: 3,
        text: i18n.t('investTypeOffers.3'),
        disabled: true,
      },
      {
        value: 4,
        text: i18n.t('investTypeOffers.4'),
        disabled: false,
      },
    ],

    plegeSubTypes: [
      {
        value: 1,
        text: i18n.t('investPlegeSubTypes.1'),
      },
      {
        value: 2,
        text: i18n.t('investPlegeSubTypes.2'),
      },
      {
        value: 3,
        text: i18n.t('investPlegeSubTypes.3'),
      },
    ],

    currencyList: [
      {
        value: "RUB",
        text: i18n.t('currencyList.rub'),
      },
      {
        value: "USD",
        text: i18n.t('currencyList.usd'),
      },
    ],

    searchCompanyDaData: null,
    avatarFile: null,

    dialogCropBaseImage: false,
    selectedFile: null,
    cropData: null,
    mime_type: null,
    loadingBase: false,

    stepsModel: {
      1: {
        createInvestCompany: null,
        title: null,
        name: null,
        type: null,
        sub_type: null,
      },
      2: {
        currency: "RUB",
        currency_callback: "RUB",
        price_min: 100000,
        price_max: 15000000,
        month_min: 3,
        month_max: 36,
        complete_price: null,
        percent: null,
        percent_table: null,
      },
      3: {
        aboutText: null,
        aboutImages: null,
        aboutOptions: null,
        businesText: null,
        businesImages: null,
        businesOptions: null,
      },
      4: {
        documents: null,
      },
    },

    loadingNextButton: false,
  }),
  components: {
    CompanySearch,
    ListFromTo,
    MyDocuments,
    OptionsList,
    GalleryList,
    Cropper,
  },

  computed: {
    percentTableExist() {
      if (!this.invest) return null;
      if (this.invest.percent_table)
        return JSON.stringify(this.invest.percent_table);
      return null;
    },

    currencyInvestIcon() {
      if (this.stepsModel[2].currency == "USD") return "mdi-currency-usd";
      return "mdi-currency-rub";
    },

    rulesMaxInvestPrice() {
      return [
        (v) => !!v || i18n.t('pagesInvest.add.rules.required'),
        (v) => !(v < 100000) || i18n.t('pagesInvest.add.rules.minValue', {value: 100000}),
        (v) =>
          !(v <= this.cPriceMin) || i18n.t('pagesInvest.add.rules.gt', {field: i18n.t('pagesInvest.add.fields.price_min')})
      ];
    },
    rulesMinInvestPrice() {
      return [
        (v) => !!v || i18n.t('pagesInvest.add.rules.required'),
        (v) => !(v < 100000) || i18n.t('pagesInvest.add.rules.minValue', {value: 100000}),
        (v) =>
          !(v >= this.cPriceMax) ||
          i18n.t('pagesInvest.add.rules.lt', {field: i18n.t('pagesInvest.add.fields.price_max')})
      ];
    },

    rulesMaxInvestMonth() {
      return [
        (v) => !!v || i18n.t('pagesInvest.add.rules.required'),
        (v) => !(v < 1) || i18n.t('pagesInvest.add.rules.minValue', {value: 1}),
        //(v) => !(v > 12) || "Максимальное значение 12",
        //(v) => !(v < this.cMonthMin) || "Значение должно быть больше 'Срок от'",
      ];
    },
    rulesMinInvestMonth() {
      return [
        (v) => !!v || i18n.t('pagesInvest.add.rules.required'),
        (v) => !(v < 1) || i18n.t('pagesInvest.add.rules.minValue', {value: 1}),
        //(v) => !(v > 48) || "Максимальное значение 48",
        //(v) => !(v > this.cMonthMax) || "Значение должно быть меньше 'Срок до'",
      ];
    },

    cPriceMin() {
      return this.stepsModel[2].price_min;
    },

    cPriceMax() {
      return this.stepsModel[2].price_max;
    },

    cMonthMin() {
      return this.stepsModel[2].month_min;
    },

    cMonthMax() {
      return this.stepsModel[2].month_max;
    },

    cErrorMin() {
      if (this.stepsModel[2].month_min >= this.stepsModel[2].month_max)
        return true;
      return false;
    },
  },

  methods: {
    onRemoveAvatar(){
      this.loadingBase = true;
      this.__updateBaseFileInvest(this.avatarFile.id, true).then((resp) => {
        this.invest = Object.assign({}, resp.data.data);
        this.investToModel();
        this.loadingBase = false;
      }).catch(()=>{
        this.loadingBase = false;
      });
    },
    getSrcPublicFile(file_id){
      return `${window.$api_url}v1/files/${file_id}/show-image`;
    },
    saveImage() {
      // let imgDataUrl = this.cropData.canvas.toDataURL();
      const { canvas } = this.$refs.cropper[0].getResult();
      if (canvas) {
        const formData = new FormData();
        formData.append("type", 11);
        formData.append("public", 1);
        this.loadingBase = true;
        canvas.toBlob((blob) => {
          formData.append("file", blob, "avatarInvest.jpg");
          uploadFile(formData)
            .then((response) => {
              if (response && response.data && response.data.result) {
                let file_id = response.data.data.id;
                this.__updateBaseFileInvest(file_id).then((resp) => {
                  this.invest = Object.assign({}, resp.data.data);
                  this.investToModel();
                  this.onCloseBaseImageCropModal();
                }).catch(()=>{
                  this.loadingBase = false;
                });
              } else {
                this.loadingBase = false;
                showNotify("error", response.data.message);
              }
            })
            .catch((error) => {
              this.loadingBase = false;
              showNotify("error", error);
            });
        });
      }
    },
    onFileSelect(e) {
      const file = e.target.files[0];
      this.mime_type = file.type;
      const reader = new FileReader();
      this.loadingBase = true;
      reader.onload = (event) => {
        this.selectedFile = event.target.result;
        // this.$refs.cropper.replace(this.selectedFile)
        this.loadingBase = false;
      };
      reader.onerror = function () {
        this.loadingBase = false;
        showNotify("error", reader.error);
      };

      reader.readAsDataURL(file);
    },
    __clearBaseImageData() {
      this.selectedFile = null;
      this.cropData = null;
      this.mime_type = null;
      this.loadingBase = false;
    },
    onOpenBaseImageCropModal() {
      this.__clearBaseImageData();
      this.dialogCropBaseImage = true;
    },
    onCloseBaseImageCropModal() {
      this.__clearBaseImageData();
      this.dialogCropBaseImage = false;
    },
    openFileBaseImage() {
      console.log("FFF", this.$refs.FileInput);
      this.$refs.FileInput[0].click();
    },
    changeCropBaseImage({ coordinates, canvas }) {
      this.cropData = Object.assign({}, { coordinates, canvas });
      console.log("changeCropBaseImage", this.cropData);
    },

    async sendToVerificator() {
      this.loadingNextButton = true;
      const url = `v1/invest/offers/${this.invest.id}/send`;
      let data = this.stepsModel;
      await apiCallTrue({ url, data, method: "POST" })
        .then(() => {
          this.backToList();
        })
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          this.loadingNextButton = false;
        });
    },
    backToList() {
      this.$router.push({ name: "Invest" });
    },
    changeListFromToPercent(percentTable) {
      this.stepsModel[2].percent_table = Object.assign({}, percentTable);
    },
    async __createInvest() {
      this.loadingNextButton = true;
      const url = `v1/invest/offers/draft`;
      let data = this.stepsModel;
      await apiCallTrue({ url, data, method: "POST" })
        .then((response) => {
          this.invest = response.data.data;
          this.investToModel();
          this.nextStep(false, true);
        })
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          this.loadingNextButton = false;
        });
    },

    __updateInvest() {
      return new Promise((resolve, reject) => {
        this.loadingNextButton = true;
        const url = `v1/invest/offers/${this.invest.id}/draft`;
        let data = this.stepsModel;
        apiCallTrue({ url, data, method: "POST" })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            showNotify("error", error);
            reject(error);
          })
          .finally(() => {
            this.loadingNextButton = false;
          });
      });
    },

    __updateBaseFileInvest(file_id, is_delete = false) {
      return new Promise((resolve, reject) => {
        const url = `v1/invest/offers/${this.invest.id}/draft/file`;
        let data = { file_id: file_id, is_delete: is_delete ? 1 : 0 };
        apiCallTrue({ url, data, method: "POST" })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            showNotify("error", error);
            reject(error);
          });
      });
    },

    investToModel() {
      if (!this.invest) return;

      //1
      this.stepsModel[1].title = this.invest.title;
      this.stepsModel[1].name = this.invest.name;
      this.stepsModel[1].type = this.invest.type;
      this.stepsModel[1].sub_type = this.invest.sub_type;

      //2
      this.stepsModel[2].currency = this.invest.currency;
      this.stepsModel[2].currency_callback = this.invest.currency_callback;
      this.stepsModel[2].price_min = this.invest.price_min;
      this.stepsModel[2].price_max = this.invest.price_max;
      this.stepsModel[2].month_min = this.invest.month_min;
      this.stepsModel[2].month_max = this.invest.month_max;
      this.stepsModel[2].complete_price = this.invest.complete_price;
      this.stepsModel[2].percent = this.invest.percent;
      this.stepsModel[2].percent_table = this.invest.percent_table;

      //3
      this.stepsModel[3].aboutText = this.invest.package.investAbout.data.text;
      this.stepsModel[3].aboutImages = this.invest.package.investAbout.data.images;
      this.stepsModel[3].aboutOptions = this.invest.package.investAbout.data.options;

      this.stepsModel[3].businesText = this.invest.package.investBusiness.data.text;
      this.stepsModel[3].businesImages = this.invest.package.investBusiness.data.images;
      this.stepsModel[3].businesOptions = this.invest.package.investBusiness.data.options;

      //4
      this.stepsModel[4].documents = Object.assign(
        {},
        this.invest.package.documents
      );

      //assign avatar
      this.avatarFile = this.invest.file;
    },
    // onInputPriceMin(){
    //    // if(this.cPriceMin >= this.cPriceMax)
    //      // this.stepsModel[2].price_max = Math.min(this.cPriceMin +100, 100000);
    // },
    // onInputPriceMax(){
    // //  if(this.cPriceMax <= this.cPriceMin)
    //       //this.stepsModel[2].price_min = Math.max(this.cPriceMax -100, 100000);
    // },

    __autoSave(nowCreated = false) {
      return new Promise((resolve, reject) => {
        if (!this.invest || nowCreated) {
          resolve();
          return;
        }

        this.__updateInvest()
          .then((resp) => {
            this.invest = Object.assign({}, resp.data.data);
            this.investToModel();
            resolve(resp);
          })
          .catch((err) => reject(err));
      });
    },
    nextStep(ajaxWait = true, nowCreated = false) {
      //update if invest exist

      //create if not exist investFV
      if (ajaxWait && this.addModalStep == 2) {
        //validate
        //(v) => !(v < this.cMonthMin) || "Значение должно быть больше 'Срок от'",
        if (
          this.stepsModel[2].month_min >= this.stepsModel[2].month_max &&
          this.stepsModel[1].type != 4
        ) {
          showNotify(
            "error",
            "Поле 'Срок от' должно быть меньше поля 'Срок до'"
          );
          return;
        }
      }
      if (ajaxWait && this.addModalStep == 2 && !this.invest) {
        this.__createInvest();
        return;
      }
      this.__autoSave(nowCreated).then(() => {
        this.addModalStep = Math.min(
          this.addModalStep + 1,
          this.addModalSteps.length
        );
      });
    },
    prevStep() {
      this.__autoSave().then(() => {
        this.addModalStep = Math.max(this.addModalStep - 1, 1);
      });
    },

    onChangeCallbackCompanySearch(obj) {
      this.stepsModel[1].createInvestCompany = obj;
      if (obj) {
        this.stepsModel[1].title = obj.name.short_with_opf;
      }
    },

    isDisabledNext(currentStep) {
      switch (currentStep) {
        case 0:
          {
            if (!this.stepsModel[1].createInvestCompany) return true;
            if (!this.stepsModel[1].title) return true;
            if (!this.stepsModel[1].name) return true;
            if (!this.stepsModel[1].type) return true;
            if (this.stepsModel[1].type == 4) {
              if (!this.stepsModel[1].sub_type) return true;
            } else {
              this.stepsModel[1].sub_type = null;
            }
          }
          break;
      }
      return false;
    },

    async updatePackageDocuments(uploadedDocument) {
      console.log("updatePackageDocuments", uploadedDocument);
    },

    updateCustomPackageDocuments(uploadedDocument) {
      if (!this.invest.package.documents.data[0].folders)
        this.invest.package.documents.data[0].folders = [];
      this.invest.package.documents.data[0].folders.push(uploadedDocument);
      console.log("updateCustomPackageDocuments", uploadedDocument);
      //this.showLoading();
      let data = {
        type: 1,
        data: this.invest.package.documents.data,
      };
      let typeStr = this.invest.package.documents.id; //"documents";

      apiCallTrue({
        url: `v1/package/${this.offer.package.id}/items/${typeStr}`,
        method: "POST",
        data,
      })
        .then(() => {})
        .catch((error) => {
          showNotify("error", error);
        })
        .finally(() => {
          //this.hideLoading();
        });
    },

    async getDraftOffer(id) {
      const url = `v1/invest/offers/${id}/draft`;
      this.isLoadingEditMode = true;
      this.errorDie = null;

      await apiCallTrue({ url })
        .then((response) => {
          this.invest = response.data.data;
          this.investToModel();
          if (this.invest) {
            this.searchCompanyDaData = this.invest.package.clientCompany.data.dadata;
          }
        })
        .catch((error) => {
          showNotify("error", error);
          this.errorDie = error.message;
        })
        .finally(() => {
          this.isLoadingEditMode = false;
        });
    },
  },
  mounted() {
    try {
      const { id } = this.$route.params;
      if (id) {
        this.getDraftOffer(id);
      }
    } catch (e) {
      console.warn(e);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
.cropper {
  height: 400px;
  max-height: 400px;
  /*background: #DDD;*/
}

.avatar-image-exist {
 /* padding: 10px;*/
}
</style>
